import React, { useEffect, useState } from 'react'
import { Button, Input, DatePicker, Form, InputNumber, Select, Table, Popconfirm } from 'antd';
import { getItem, createItem, deleteItem } from '../../controller/Control';
import { GrDocumentUser } from "react-icons/gr";
import { IoSearch } from "react-icons/io5";
import { LuCalendarPlus, LuTrash2 } from "react-icons/lu";
import './styles.css'
import type { FormProps } from 'antd';

interface Patient {
	name: string;
	document: string;
	createdAt: string;
	// Agrega otras propiedades según sea necesario
}

interface PacientesProps {
  userId: (id: string) => void;
}

const Pacientes: React.FC<PacientesProps> = ({userId}) => {
	const [ dataPatients, setDataPatients] = useState<Patient[]>([])
	const [ dataPatientsFilter, setDataPatientsFilter] = useState<Patient[]>([])
	const [ patientsActions, setPatientsActions ] = useState({
		view: false,
		add: false,
		edit: false
	})
	const [form] = Form.useForm();
	

	const getData = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/patient` || 'localhost:3000', token)
		setDataPatients(data)
	}

	useEffect(() => {
		getData()
	}, [0])

	useEffect(() => {
		getData()
	}, [patientsActions])

	const createData = async(values: FormProps) => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const create = await createItem(`${process.env.REACT_APP_API_SERVER}/patient` || 'localhost:3000', values, token)
		if(create === 401){
			alert('Error General, intente nuevamente')
		}
		if(create === 409){
			alert('Ya existe un paciente con el mismo numero de documento')
		}
		if(create._id){
			alert('Paciente creado con exito')
			form.resetFields();
			setPatientsActions({view: false, add: false, edit: false})
		}
	}

	const handleSubmit = (values: FormProps) => {
		createData(values)
	}

	const searchUser = (val: any) => {
		const data = val.target.value
		const dataFilter = dataPatients.filter((a) => a.name.toLowerCase().includes(data) || a.document.includes(data))
		setDataPatientsFilter(dataFilter)
	}

	const moreInfo = (a: any) => {
		userId(a._id)
	}

	const addCalendar = (a: any) => {
		console.log(a)
	}

	const deletePatient = async(data: any) => {
        const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const create = await deleteItem(`${process.env.REACT_APP_API_SERVER}/patient/${data._id}` || 'localhost:3000', token)
		if(create._id){
			getData()
		}
    }

	const columns = [
		{
			title: 'Nombre',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Documento',
			dataIndex: 'document',
			key: 'document',
		},
		{
			title: 'Fecha Creación',
			render: (a: any) => new Date(a.createdAt).toLocaleString('es-ES', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: true, // Usa formato de 24 horas
			}),
			key: 'created',
			sorter: (a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
			defaultSortOrder: 'descend' as const
		},
		{
			title: 'Ver Más',
			render: (a: any) => <GrDocumentUser size={20} color='#B71C1C' style={{cursor: 'pointer'}} onClick={() => moreInfo(a)}/>,
			key: 'mas',
			width: 100
		},
		{
            title: 'Eliminar',
            render: (a: any) => <Popconfirm 
                title="Seguro quiere eliminar este paciente?"
                description="Esta acción no se puede deshacer"
                cancelText="Cancelar"
                onConfirm={() => deletePatient(a)}
            >
                <LuTrash2 size={20} color='red' style={{cursor: 'pointer'}}/>
            </Popconfirm>

        }
	];

	return(
		<div className='px-5'>
			<div className='my-5 flex flex-col md:flex-row'>
				<div>
					{!patientsActions.view ?
					<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' onClick={() => setPatientsActions({view: true, add: true, edit: false})}>Agregar Paciente</button> : null}
				</div>
				<div className='my-5 sm:w-full md:w-60 md:mx-5 md:my-0'>
					<Input placeholder='Busca por paciente o documento' onChange={searchUser} prefix={<IoSearch />} allowClear={true}/>
				</div>
			</div>
			<div className='justify-center flex-col items-center patient' style={patientsActions.view ? {display: 'flex'} : {display: 'none'}}>
				<h1 className='text-2xl text-text-menu my-5'>{patientsActions.add ? 'Agrega un Paciente' : patientsActions.edit ? 'Modificar un Paciente' : null}</h1>
				<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
					<Form
						layout='vertical'
						style={{maxWidth: 400}}
						onFinish={handleSubmit}
						form={form}
					>

						<Form.Item label="Nombre" name="name" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Documento" name="document" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item
							label="Cumpleaños"
							name="birthdate"
							rules={[{ required: true, message: 'Por favor llene este campo' }]}
						>
							<DatePicker style={{ width: '100%' }}/>
						</Form.Item>

						<Form.Item
							label="Edad"
							name="age"
							rules={[{ required: true, message: 'Por favor llene este campo' }]}
						>
							<InputNumber style={{ width: '100%' }} />
						</Form.Item>

						<Form.Item label="Originario de" name="from" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Vive en" name="live" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Ocupacion" name="occupation" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Teléfono" name="phone" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Correo" name="email" rules={[{ type: 'email', required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Estado Civil" name="status">
							<Select>
								<Select.Option value="soltero">Soltero</Select.Option>
								<Select.Option value="casado">Casado</Select.Option>
								<Select.Option value="divorciado">Divorciado</Select.Option>
								<Select.Option value="union de hecho">Unión de Hecho</Select.Option>
								<Select.Option value="viudo">Viudo</Select.Option>
							</Select>
						</Form.Item>

						<Form.Item label="Lateralidad" name="laterality">
							<Select>
								<Select.Option value="diestro">Diestro</Select.Option>
								<Select.Option value="siniestro">Siniestro</Select.Option>
							</Select>
						</Form.Item>

						<Form.Item label="Genero" name="gender">
						<Select>
								<Select.Option value="masculino">Masculino</Select.Option>
								<Select.Option value="femenino">Femenino</Select.Option>
							</Select>
						</Form.Item>

						<Form.Item>
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' type="submit">
								Agregar
							</button>
							<button className='bg-text-menu ml-2 text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' onClick={() => setPatientsActions({view: false, add: false, edit: false})}>
								Cancelar
							</button>
						</Form.Item>
					</Form>
				</div>
			</div>
			<div>
				<Table 
					dataSource={dataPatientsFilter.length === 0 ? dataPatients : dataPatientsFilter} 
					columns={columns}
				/>
			</div>
		</div>
	)
}

export default Pacientes